import React from 'react'
import ReactDOM from 'react-dom'
import s from './ErrorBanner.module.scss'

const ErrorBanner = ({ message }) => {
	if (!message) return null

	return ReactDOM.createPortal(
		<div className={s.overlay}>
			<div className={s.banner}>{message}</div>
		</div>,
		document.body,
	)
}

export default ErrorBanner
